import { useForegroundNotification } from "@/lib/push-notification-manager";
import { Bell, X, UserCircle } from "lucide-react";

export function ForegroundNotificationBanner() {
  const { foregroundNotification, dismissNotification } = useForegroundNotification();

  if (!foregroundNotification) return null;

  const isDifferentUser = foregroundNotification.isForDifferentUser;
  const otherUser = foregroundNotification.targetUserName || foregroundNotification.targetUserEmail;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[9999] p-2 animate-in slide-in-from-top duration-300"
      data-testid="foreground-notification-banner"
    >
      <div className="mx-auto max-w-md bg-card border shadow-lg rounded-md p-3 flex items-start gap-3">
        <div className="flex-shrink-0 mt-0.5">
          {isDifferentUser ? (
            <UserCircle className="h-5 w-5 text-muted-foreground" />
          ) : (
            <Bell className="h-5 w-5 text-primary" />
          )}
        </div>
        <div className="flex-1 min-w-0">
          {isDifferentUser && otherUser && (
            <p className="text-xs text-muted-foreground mb-0.5" data-testid="text-notification-other-user">
              For {otherUser}
            </p>
          )}
          <p className="font-medium text-sm truncate" data-testid="text-notification-title">
            {foregroundNotification.title}
          </p>
          {foregroundNotification.body && (
            <p className="text-xs text-muted-foreground mt-0.5 line-clamp-2" data-testid="text-notification-body">
              {foregroundNotification.body}
            </p>
          )}
          {isDifferentUser && (
            <p className="text-xs text-muted-foreground mt-1 italic" data-testid="text-switch-hint">
              Switch accounts to view details
            </p>
          )}
        </div>
        <button
          onClick={dismissNotification}
          className="flex-shrink-0 p-1 rounded-sm hover-elevate"
          data-testid="button-dismiss-notification"
        >
          <X className="h-4 w-4 text-muted-foreground" />
        </button>
      </div>
    </div>
  );
}
